<template>
    <div>

        <el-dialog :visible.sync="dialogFormVisible" v-if="dialogFormVisible" width="600px">

            <div style="width: 50%;margin: 0 auto 20px;">{{ $i18n.t('common.BlackList') }}</div>

            <el-form
                 ref="addUserBlackForm"
                 :model="addUserBlackData"
                 :rules="formRules"

            >
                <el-form-item prop="reason" :label='$i18n.t("common.reason")' label-width="120px" required>
                    <el-input type="textarea" :rows="5" :placeholder='$i18n.t("common.ReasonRequired")' v-model="addUserBlackData.reason" maxlength="500" show-word-limit></el-input>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">{{ $i18n.t('common.cancel') }}</el-button>
                <el-button type="primary" @click="addUserBlack">{{ $i18n.t('common.confirm1') }}</el-button>
            </div>


        </el-dialog>

    </div>
</template>

<script>

    import scene from '../../utils/scene';


    export default {
        name: 'addUserBlackDialog',
        components: {
        },
        data() {
            return {
                addUserBlackData: {
                    userId: null,
                    reason: ''
                },
                dialogFormVisible: false,
                formRules: {
                    reason: [{ required: true, message: this.$i18n.t("common.ReasonRequired"), trigger: 'blur' }]
                },
            };
        },
        watch: {
            deep: true
        },
        computed: {
            scene() {
                return scene;
            }
        },
        methods: {

            addUserBlack() {

                var that = this;
                this.$refs.addUserBlackForm.validate(function (isOK) {
                    if (isOK) {

                        that.$store.dispatch('addUserBlack', that.addUserBlackData).then(response => {
                            that.$message({
                                message: that.$i18n.t("common.SubmittedSuccessfully"),
                                type: 'success',
                                duration: 1000
                            });
                            that.dialogFormVisible = false;
                            that.$emit('reloadList');
                        });
                    }
                })
            },
            addUserBlackDialog(userId) {

                this.addUserBlackData.userId = userId;
                this.addUserBlackData.reason = "";
                this.dialogFormVisible = true;
            }

        }
    };
</script>
<style scoped>
</style>
